import { render, staticRenderFns } from "./securityScreen.vue?vue&type=template&id=81986e78&scoped=true"
import script from "./securityScreen.vue?vue&type=script&lang=js"
export * from "./securityScreen.vue?vue&type=script&lang=js"
import style0 from "./securityScreen.vue?vue&type=style&index=0&id=81986e78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81986e78",
  null
  
)

export default component.exports